import { render, staticRenderFns } from "./sliceUpload.vue?vue&type=template&id=7346c0d0&scoped=true"
import script from "./sliceUpload.vue?vue&type=script&lang=js"
export * from "./sliceUpload.vue?vue&type=script&lang=js"
import style0 from "./sliceUpload.vue?vue&type=style&index=0&id=7346c0d0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346c0d0",
  null
  
)

export default component.exports